import { PublicClientApplication, LogLevel } from '@azure/msal-browser'
import { getEnvFlag } from './env'

// Strip any trailing slash so we never build `//auth/callback` — Azure matches
// redirect URIs exactly, and the deployed value may end with a slash.
const baseUrl = (process.env.REACT_APP_AAD_REDIRECT_URL || '').replace(
  /\/+$/,
  '',
)

export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_AAD_CLIENT_ID,
    authority: process.env.REACT_APP_AAD_AUTHORITY,
    redirectUri: `${baseUrl}/auth/callback`,
    // Reuse the already-registered callback URI for post-logout, so the browser
    // returns to the app (AuthCallback → '/') without needing the bare root
    // registered separately in Azure.
    postLogoutRedirectUri: `${baseUrl}/auth/callback`,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: true,
    secureCookies: process.env.NODE_ENV === 'production',
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return
        if (process.env.NODE_ENV === 'development') {
          console.log(`[MSAL] ${message}`)
        }
      },
      logLevel: LogLevel.Warning,
    },
  },
}

export const loginRequest = {
  scopes: ['openid', 'profile', 'email'],
}

const isSsoEnabled = getEnvFlag('REACT_APP_ENABLE_AAD_LOGIN')

export const msalInstance = isSsoEnabled
  ? new PublicClientApplication(msalConfig)
  : null
